// import { useEffect, useReducer, useCallback, useMemo } from 'react';
// import { enqueueSnackbar } from 'notistack';
// import axiosInstance, { endpoints } from 'src/utils/axios';
// import axios from 'axios';
// import { AuthContext } from './auth-context';
// import { setSession } from './utils';
// import { ActionMapType, AuthStateType, AuthUserType } from '../../types';

// enum Types {
//   INITIAL = 'INITIAL',
//   LOGIN = 'LOGIN',
//   REGISTER = 'REGISTER',
//   LOGOUT = 'LOGOUT',
// }

// type Payload = {
//   [Types.INITIAL]: {
//     user: AuthUserType;
//   };
//   [Types.LOGIN]: {
//     user: AuthUserType;
//   };
//   [Types.REGISTER]: {
//     user: AuthUserType;
//   };
//   [Types.LOGOUT]: undefined;
// };

// type ActionsType = ActionMapType<Payload>[keyof ActionMapType<Payload>];

// // ---------------------------------------------------------------------- 

// const initialState: AuthStateType = {
//   user: null,
//   loading: true,
// };

// const reducer = (state: AuthStateType, action: ActionsType) => {
//   if (action.type === Types.INITIAL) {
//     return {
//       loading: false,
//       user: action.payload.user,
//     };
//   }
//   if (action.type === Types.LOGIN) {
//     return {
//       ...state,
//       user: action.payload.user,
//     };
//   }
//   if (action.type === Types.REGISTER) {
//     return {
//       ...state,
//       user: action.payload.user,
//     };
//   }
//   if (action.type === Types.LOGOUT) {
//     return {
//       ...state,
//       user: null,
//     };
//   }
//   return state;
// };

// // ----------------------------------------------------------------------

// const STORAGE_KEY = 'accessToken';

// type Props = {
//   children: React.ReactNode;
// };

// export function AuthProvider({ children }: Props) {
//   const [state, dispatch] = useReducer(reducer, initialState);
//   const initialize = useCallback(async () => {
//     try {
//       const accessToken = localStorage.getItem('accessToken');

//       if (accessToken) {
//         setSession(accessToken);
//         const userid = localStorage.getItem('user_id');
//         const res = await axiosInstance.get(`${endpoints.admin.getsingleadmin}?user_id=${userid}`);
//         const user = res.data;
//         // console.log(res)
//         dispatch({
//           type: Types.INITIAL,
//           payload: {
//             user,
//           },
//         });
//       } else {
//         dispatch({
//           type: Types.INITIAL,
//           payload: {
//             user: null,
//           },
//         });
//       }
//     } catch (error) {
//       dispatch({
//         type: Types.INITIAL,
//         payload: {
//           user: null,
//         },
//       });
//     }
//   }, []);

//   // useEffect(() => {
//   //   initialize();
//   // }, [initialize]);

//   useEffect(() => {
//     initialize();
//     const clearCacheData = () => {
//       caches.keys().then((names) => {
//           names.forEach((name) => {
//               caches.delete(name);
//           });
//       });
//       // alert("Complete Cache Cleared");
      
//   };
//   clearCacheData();

//   }, [initialize]);

//   // useEffect(()=>{
//   //   const clearCacheData = () => {
//   //     caches.keys().then((names) => {
//   //         names.forEach((name) => {
//   //             caches.delete(name);
//   //         });
//   //     });
//   //     // alert("Complete Cache Cleared");
      
//   // };
//   // clearCacheData();
//   // },[]) 

//   // LOGIN
//   const login = useCallback(async (username: string, password: string) => {
//     const details = {
//       username,
//       password,
//       device_token: 'realdeviceid',
//     };
//     const res = await axiosInstance.post(endpoints.test.login, details);
//     const { accessToken } = res.data;
//     localStorage.setItem('token', res.data.accessToken);
//     const user = res.data.data;
//     localStorage.setItem('user_id', res.data.data.user_id);
//     setSession(accessToken);
//     sessionStorage.setItem(STORAGE_KEY, accessToken);
//     enqueueSnackbar(res.data.message);
//     dispatch({
//       type: Types.LOGIN,
//       payload: {
//         user,
//       },
//     });
//   }, []);

//   const register = useCallback(
//     async (email: string, password: string, firstName: string, lastName: string) => {
//       const data = {
//         email,
//         password,
//         firstName,
//         lastName,
//       };

//       const res = await axios.post(endpoints.auth.register, data);

//       const { accessToken, user } = res.data;

//       sessionStorage.setItem(STORAGE_KEY, accessToken);

//       dispatch({
//         type: Types.REGISTER,
//         payload: {
//           user,
//         },
//       });
//     },
//     []
//   );

//   // LOGOUT
//   const logout = useCallback(async () => {
//     setSession(null);
//     dispatch({
//       type: Types.LOGOUT,
//     });
//   }, []);

//   // ----------------------------------------------------------
//   const checkAuthenticated = state.user ? 'authenticated' : 'unauthenticated';

//   const status = state.loading ? 'loading' : checkAuthenticated;

//   const memoizedValue = useMemo(
//     () => ({
//       user: state.user,
//       method: 'jwt',
//       loading: status === 'loading',
//       authenticated: status === 'authenticated',
//       unauthenticated: status === 'unauthenticated',
//       //
//       login,
//       register,
//       logout,
//     }),
//     [login, logout, register, state.user, status]
//   );

//   return <AuthContext.Provider value={memoizedValue}>{children}</AuthContext.Provider>;
// } 








import { useEffect, useReducer, useCallback, useMemo } from 'react';
import { enqueueSnackbar } from 'notistack';
import axiosInstance, { endpoints } from 'src/utils/axios';
import axios from 'axios';
import { AuthContext } from './auth-context';
import { setSession } from './utils';
import { ActionMapType, AuthStateType, AuthUserType } from '../../types';

// ----------------------------------------------------------------------

enum Types {
  INITIAL = 'INITIAL',
  LOGIN = 'LOGIN',
  REGISTER = 'REGISTER',
  LOGOUT = 'LOGOUT',
}

type Payload = {
  [Types.INITIAL]: {
    user: AuthUserType;
  };
  [Types.LOGIN]: {
    user: AuthUserType;
  };
  [Types.REGISTER]: {
    user: AuthUserType;
  };
  [Types.LOGOUT]: undefined;
};

type ActionsType = ActionMapType<Payload>[keyof ActionMapType<Payload>];

// ----------------------------------------------------------------------

const STORAGE_KEY = 'accessToken';

/**
 * FIX #1 — Blink Fix:
 * Agar localStorage mein token already hai, tabhi loading=true rakh.
 * Warna seedha loading=false — isse initial blink nahi aayega.
 */

const initialState: AuthStateType = {
  user: null,
  loading: !!localStorage.getItem(STORAGE_KEY),
};

const reducer = (state: AuthStateType, action: ActionsType) => {
  if (action.type === Types.INITIAL) {
    return {
      loading: false,
      user: action.payload.user,
    };
  }
  if (action.type === Types.LOGIN) {
    return {
      ...state,
      user: action.payload.user,
    };
  }
  if (action.type === Types.REGISTER) {
    return {
      ...state,
      user: action.payload.user,
    };
  }
  if (action.type === Types.LOGOUT) {
    return {
      ...state,
      user: null,
    };
  }
  return state;
};

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export function AuthProvider({ children }: Props) {
  const [state, dispatch] = useReducer(reducer, initialState);

  // ----------------------------------------------------------------------

  const initialize = useCallback(async () => {
    console.log(localStorage.getItem(STORAGE_KEY))
    try {
      /**
       * FIX #2 — Ek consistent key use karo:
       * Pehle code mein 'accessToken' aur 'token' dono alag alag
       * jagah store ho rahe the — ab sirf STORAGE_KEY use karo.
       */
      const accessToken = localStorage.getItem(STORAGE_KEY);

      if (accessToken) {
        setSession(accessToken);

        const userid = localStorage.getItem('user_id');

        const res = await axiosInstance.get(
          `${endpoints.admin.getsingleadmin}?user_id=${userid}`
        );

        const user = res.data;

        dispatch({
          type: Types.INITIAL,
          payload: { user },
        });
      } else {
        dispatch({
          type: Types.INITIAL,
          payload: { user: null },
        });
      }
    } catch (error) {
      /**
       * FIX #3 — Error aane pe token saaf karo:
       * Agar API fail ho gayi (expired token, network error),
       * toh purana kharab token localStorage mein pada rehta tha
       * aur page baar baar blink karta rehta tha.
       * Ab catch mein dono keys remove kar dete hain.
       */

      localStorage.removeItem(STORAGE_KEY);
      localStorage.removeItem('user_id');

      dispatch({
        type: Types.INITIAL,
        payload: { user: null },
      });
    }
  }, []);

  // ----------------------------------------------------------------------

// auth-provider.tsx

useEffect(() => {
  initialize();
}, [initialize]);

// ✅ Cache clear — completely separate, no race condition
useEffect(() => {
  caches.keys().then((names) => {
    names.forEach((name) => caches.delete(name));
  });
}, []);

  // ----------------------------------------------------------------------

  // LOGIN
  const login = useCallback(async (username: string, password: string) => {
    const details = {
      username,
      password,
      device_token: 'realdeviceid',
    };

    const res = await axiosInstance.post(endpoints.test.login, details);

    const { accessToken } = res.data;
    const user = res.data.data;

    /**
     * FIX #5 — Sirf localStorage use karo:
     * Pehle 'token' alag key se aur 'accessToken' alag key se
     * store ho raha tha — plus sessionStorage mein bhi duplicate tha.
     * Ab sirf ek jagah, ek key se store karo.
     */
    localStorage.setItem(STORAGE_KEY, accessToken);
    localStorage.setItem('user_id', res.data.data.user_id);

    setSession(accessToken);

    enqueueSnackbar(res.data.message);

    dispatch({
      type: Types.LOGIN,
      payload: { user },
    });
  }, []);

  // ----------------------------------------------------------------------

  // REGISTER
  const register = useCallback(
    async (email: string, password: string, firstName: string, lastName: string) => {
      const data = {
        email,
        password,
        firstName,
        lastName,
      };

      const res = await axios.post(endpoints.auth.register, data);

      const { accessToken, user } = res.data;

      /**
       * Register mein bhi consistent key use karo
       */
      localStorage.setItem(STORAGE_KEY, accessToken);

      dispatch({
        type: Types.REGISTER,
        payload: { user },
      });
    },
    []
  );

  // ----------------------------------------------------------------------

  // LOGOUT
  const logout = useCallback(async () => {
    /**
     * FIX #6 — Logout pe sab kuch clean karo:
     * Pehle sirf setSession(null) tha —
     * wahi rehti thi. Agli baar open karne pe stale data
     * se conflict hoti thi aur blink aata tha.
     */
    localStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem('user_id');

    setSession(null);

    dispatch({
      type: Types.LOGOUT,
    });
  }, []);

  // ----------------------------------------------------------------------

  const checkAuthenticated = state.user ? 'authenticated' : 'unauthenticated';

  const status = state.loading ? 'loading' : checkAuthenticated;

  const memoizedValue = useMemo(
    () => ({
      user: state.user,
      method: 'jwt',
      loading: status === 'loading',
      authenticated: status === 'authenticated',
      unauthenticated: status === 'unauthenticated',
      //
      login,
      register,
      logout,
    }),
    [login, logout, register, state.user, status]
  );

  return <AuthContext.Provider value={memoizedValue}>{children}</AuthContext.Provider>;
}

